import React from 'react'
import { BootstrapIcon } from './BootstrapIcon'
import { FontAwesomeIcon } from './FontAwesomeIcon'
import { FontAwesome6Icon } from './FontAwesome6Icon'
import type { IconType} from '@ztechapps/common.hook';
import { useTheme } from '@ztechapps/common.hook'

export type IconProps = {
  className?: string | undefined
  name?: string
  title?: string
  type?: IconType
  style?: any
  rotation?: number
}

export const Icon = ({ className, name, title, type, ...props }: IconProps) => {
  const { iconType } = useTheme()
  type = type ?? iconType

  if (type === 'fa6i') {
    return <FontAwesome6Icon name={name} type={type} className={className} title={title} rotation={props.rotation} style={props.style} />
  }

  if (type === 'bi') {
    return <BootstrapIcon name={name} type={type} className={className} title={title} />
  }

  //fallback to FontAwesome
  return <FontAwesomeIcon name={name} type={type} className={className} title={title} />
}
